import { render, staticRenderFns } from "./BinInfoPopup.vue?vue&type=template&id=4843aee1&scoped=true"
import script from "./BinInfoPopup.vue?vue&type=script&lang=js"
export * from "./BinInfoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843aee1",
  null
  
)

export default component.exports